/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 * See the LICENSE file for the full text.
 */

/**
 * boardClient — the one API helper every motion board screen shares.
 *
 * ONE, NOT ONE EACH. The board and the index both read public tables with the
 * app's own credentials. When each page built its own helper, the two raced to
 * mint the app token and the index's reads came back 403 while the board's
 * worked — a confusing failure that looks exactly like a permissions problem
 * and is not one. Sharing the helper means the token is minted once and every
 * screen rides on it.
 *
 * It carries the app's credentials, not a person's: a visitor with no session
 * reads a public board through this, which is the whole point of the board
 * being public.
 */

import APIHelper from '../../../api/APIHelper';
import envConfig from '../../../config/envConfig';

const boardClient = new APIHelper({
  apiUrl: envConfig.backendApiUrl,
  tokenUrl: envConfig.backendTokenUrl,
  clientId: envConfig.clientKey,
  clientSecret: envConfig.clientSecret,
});

export default boardClient;
